import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ApiResponse, ProductDto, ProductCategoryDto, ProductSubcategoryDto, BrandDto } from '../models/product.dto';

@Injectable({
  providedIn: 'root'
})
export class ProductService {
  private apiUrl = `${environment.apiUrl}/api/arkifihubproduct`;

  constructor(private http: HttpClient) { }

  getProducts(
    platformId: string,
    env: 'Live' | 'Test',
    options?: {
      categoryId?: number;
      brandId?: string;
      subcategoryId?: number;
      searchTerm?: string;
      pageNumber?: number;
      pageSize?: number;
      sortBy?: string;
      sortOrder?: 'asc' | 'desc';
    }
  ): Observable<ApiResponse<ProductDto[]>> {
    let params = new HttpParams()
      .set('platformId', platformId)
      .set('environment', env);

    if (options?.categoryId) {
      params = params.set('categoryId', options.categoryId.toString());
    }
    if (options?.brandId) {
      params = params.set('brandId', options.brandId);
    }
    if (options?.subcategoryId) {
      params = params.set('subcategoryId', options.subcategoryId.toString());
    }
    if (options?.searchTerm) {
      params = params.set('searchTerm', options.searchTerm);
    }
    if (options?.pageNumber) {
      params = params.set('pageNumber', options.pageNumber.toString());
    }
    if (options?.pageSize) {
      params = params.set('pageSize', options.pageSize.toString());
    }
    if (options?.sortBy) {
      params = params.set('sortBy', options.sortBy);
    }
    if (options?.sortOrder) {
      params = params.set('sortOrder', options.sortOrder);
    }

    return this.http.get<ApiResponse<ProductDto[]>>(this.apiUrl, { params });
  }

  getProductById(productId: string, platformId: string, env: 'Live' | 'Test'): Observable<ApiResponse<ProductDto>> {
    const params = new HttpParams()
      .set('platformId', platformId)
      .set('environment', env);

    return this.http.get<ApiResponse<ProductDto>>(`${this.apiUrl}/${productId}`, { params });
  }

  getCategories(platformId: string, env: 'Live' | 'Test'): Observable<ApiResponse<ProductCategoryDto[]>> {
    const params = new HttpParams()
      .set('platformId', platformId)
      .set('environment', env);

    return this.http.get<ApiResponse<ProductCategoryDto[]>>(`${this.apiUrl}/categories`, { params });
  }

  getSubcategories(categoryId: number, platformId: string, env: 'Live' | 'Test'): Observable<ApiResponse<ProductSubcategoryDto[]>> {
    const params = new HttpParams()
      .set('categoryId', categoryId.toString())
      .set('platformId', platformId)
      .set('environment', env);

    return this.http.get<ApiResponse<ProductSubcategoryDto[]>>(`${this.apiUrl}/subcategories`, { params });
  }

  getBrands(platformId: string, env: 'Live' | 'Test'): Observable<ApiResponse<BrandDto[]>> {
    const params = new HttpParams()
      .set('platformId', platformId)
      .set('environment', env);

    return this.http.get<ApiResponse<BrandDto[]>>(`${this.apiUrl}/brands`, { params });
  }
}
